import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import {
  ShipmentWaybillNotificationsLoad,
  ShipmentWaybillNotificationsSetInitialState,
} from './shipment-waybill-notifications.actions';
import { ShipmentWaybillNotificationsService } from './shipment-waybill-notifications.service';
import { LatestNotification } from '../../../monitoring/models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentWaybillNotificationsStateModel {
  notifications: LatestNotification[];
  loaded: boolean;
}

const initialState: ShipmentWaybillNotificationsStateModel = {
  notifications: null,
  loaded: false,
};

@State<ShipmentWaybillNotificationsStateModel>({
  name: 'shipmentWaybillNotifications',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillNotificationsState {
  constructor(
    private shipmentWaybillNotificationsService: ShipmentWaybillNotificationsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: ShipmentWaybillNotificationsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getNotifications(state: ShipmentWaybillNotificationsStateModel): LatestNotification[] {
    return state.notifications;
  }

  @Action(ShipmentWaybillNotificationsLoad)
  getShipmentWaybillNotifications(
    ctx: StateContext<ShipmentWaybillNotificationsStateModel>,
    { payload }: ShipmentWaybillNotificationsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentWaybillNotificationsService.getShipmentWaybillNotifications(payload).pipe(
      map((notifications: LatestNotification[]) => {
        ctx.patchState({ notifications, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillNotificationsSetInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillNotificationsStateModel>): void {
    ctx.setState(initialState);
  }
}
